import { api } from "./api";

export const promotionalOfferAddApi = (params) => {
  return api.post(`/settings/promotional-offer/add`, JSON.stringify(params));
};

export const promotionalOfferUpdateApi = (params) => {
  return api.post(`/settings/promotional-offer/update`, JSON.stringify(params));
};

export const promotionalOfferDeleteApi = (params) => {
  return api.post(`/settings/promotional-offer/delete`, JSON.stringify(params));
};

export const promotionalOfferListApi = (params) => {
  return api.get(`/settings/promotional-offer/list`, { params: params });
};

export const promotionalOfferViewApi = (params) => {
  return api.get(`/settings/promotional-offer/get`, { params: params });
};

export const promotionalOfferActiveApi = (params) => {
  return api.get(`/promotional-offer/active`, { params: params });
};
